"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeEngineLogger = exports.EngineLogger = void 0;
let internal = console;
exports.EngineLogger = new Proxy(internal, {
    get(_target, p, _receiver) {
        return internal[p];
    }
});
function changeEngineLogger(logger) {
    internal = logger;
}
exports.changeEngineLogger = changeEngineLogger;
